import { TruckMaterialType } from "../../../../enums/truckMaterialType";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import { formatNumber } from "../../../../utils/numberFormatterUtil";

export const QuoteFields = {
  email: "Email",
  phone: "Phone",
  printname: "Print Name",
  title: "Title",
  date: "Date",
  paymentHeader: "Payment Terms",
  signatureHeader: "Signature",
  signedFor: "Signed for",
  signedForTn: "Signed for Twisted Nail Brokers Services, LLC.",
  address1: "Twisted Nail Broker Services, LLC.",
  address2: "266 Pioneer Parkway, Waco, Texas 76708",
  address3: "254.651.3597 | info@twistednail.com",
  header: "Aggregate Supply Quote",
  locationInfo:
    "The following agreement is for the transportation and supply/removal of material to/from the jobsite located at:",
};

export const ImgAltTexts = {
  logoAltText: "TN Logo",
  signatureAltText: "Signature",
};

export const getColumns = () => {
  return [
    {
      title: "Pick Up",
      dataIndex: "origin",
      key: "origin",
      width: "200px",
      render: (text, record) => {
        return (
          <ConditionalRender visible={!!text} fallback={" - "}>
            {text}
          </ConditionalRender>
        );
      },
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
      width: "200px",
      render: (text, record) => {
        return (
          <ConditionalRender visible={!!text} fallback={" - "}>
            {text}
          </ConditionalRender>
        );
      },
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: "180px",
      render: (text, record) => {
        const value = record?.value ?? record?.materialTruckName;
        return (
          <ConditionalRender visible={!!value} fallback={" - "}>
            {value}
          </ConditionalRender>
        );
      },
    },
    {
      title: "Truck Type",
      dataIndex: "truckType",
      key: "truckType",
      width: "128px",
      render: (text) => (
        <>{text && text.join ? text.join(" , ") : text || "-"}</>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: "105px",
      render: (text, record) => (
        <ConditionalRender visible={!!text} fallback={"-"}>
          {formatNumber(Number(text).toFixed(2)) + " " + record?.quantityUnitType}
        </ConditionalRender>
      ),
    },
    {
      title: "Material Price",
      dataIndex: "materialPrice",
      key: "materialPrice",
      width: "132px",
      render: (text, record) => (
        <ConditionalRender visible={!!text} fallback={"-"}>
          {"$" +
            formatNumber(Number(text).toFixed(2)) +
            " / " +
            record?.materialPriceType}
        </ConditionalRender>
      ),
    },
    {
      title: "Trucking Price",
      dataIndex: "truckingPrice",
      key: "truckingPrice",
      width: "136px",
      render: (text, record) => (
        <ConditionalRender visible={!!text} fallback={"-"}>
          {"$" +
            formatNumber(Number(text).toFixed(2)) +
            " / " +
            record?.truckingPriceType}
        </ConditionalRender>
      ),
    },
    {
      title: "Landed Price",
      dataIndex: "landedPrice",
      key: "landedPrice",
      width: "128px",
      render: (text, record) => {
        if(record?.type === TruckMaterialType.MATERIAL_TYPE)
          return (
            <ConditionalRender
              visible={!!record?.landedPrice && !!record?.landedPriceType}
              fallback={" - "}
            >
              {`$${formatNumber(record?.landedPrice)} / ${record?.landedPriceType}`}
            </ConditionalRender>
          );
        else if(record?.type === TruckMaterialType.TRUCK_TYPE)
          return (
            <ConditionalRender
              visible={!!record?.truckingPrice && !!record?.truckingPriceType}
              fallback={" - "}
            >
              {`$ ${formatNumber(Number(record?.truckingPrice).toFixed(2))} / ${record?.truckingPriceType}`}
            </ConditionalRender>
          );
      },
    },
  ];
};

export const getDocumentRows = (data: DocumentType, type: string) => {
  return data?.data?.[type]?.map?.((content) => {
    return {
      ...content,
      label: content?.templateName,
      value: content?.id,
    };
  });
};

